import React from 'react'
import moment from "moment/moment"
import _padStart from "lodash/padStart"

export default class HourSelect extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            open: false,
            hour: this.props.hour
        }
        this.arrow = "url(data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAJCAYAAAAGuM1UAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4goPAAg1G+FW9QAAAFVJREFUGNOVkcERgCAMBBfHpkIzoTOGYqCt8+FHEXWy3+xNkrkkSQTYCBIO7ABjDFprn6KZUUo5N+Sccfdf+XbSW+gqP36YQ7MMgBb03lVrXY2Uoj0cfvNGzZtlOSMAAAAASUVORK5CYII=)"
    }

    formatHour(hour) {
        return moment(hour, "H:mm").format("HH:mm A")
    }


    renderHours = () => {
        let result = []
        let minutes = ['00', '15', '30', '45']
        for (let i = 0; i <= 23; i++) {
            result = result.concat(minutes.map((m) => {
                let h = _padStart((i.toString() + ':' + m), 5, '0')
                return (
                    <option key={h} value={h}>{h}</option>
                )
            }))
        }
        return result
    }


    render() {
        if (this.state.open)
            return (
                <select onChange={(e) => this.setState({hour: e.target.value, open: false})}
                        defaultValue={this.state.hour}
                        onBlur={() => this.setState({open: false})}
                >
                    {this.renderHours()}
                </select>
            )
        else
            return (
                <span onClick={() => this.setState({open: true})} style={{cursor: 'pointer'}}>
                    {this.formatHour(this.state.hour)} <span style={{backgroundImage: this.arrow, width: 10, height: 10, display: 'inline-block'}} />
            </span>
            )
    }
}